let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6l2Go")).then(() => parcelRequire('dEEk1'));